import "../assets/css/App.css";
import * as React from "react";
import PropTypes from "prop-types";
import {
  Tab,
  Box,
  Card,
  Grid,
  Tabs,
  Typography,
  CardContent,
} from "@mui/material";
import logoST from "../assets/images/LogoSTL.svg";
import logoLolify from "../assets/images/Lilofy_color.png";
import LoginComponent from "../components/login/Login.component";
import { account } from "../shared/Utils";
//import { useEffect } from "react";
//import { account } from "./Utils";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const fabStyle = {
  position: "fixed",
  bottom: 16,
  right: 16,
  color: "white",
  fontSize: "1.3rem",
};

function LoginPage() {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  React.useEffect(() => {
    document.title = "Lilofy | Login";
    account.removeToken()
    account.removeDatosUsuario()
  }, [])


  return (
    <Box minHeight={"95vh"}>
      <Grid
        container
        direction={"column"}
        justifyContent="center"
        alignItems="center"
      >
        <Grid item sx={{ textAlign: "center" }}>
          <Box display={"flex"} justifyContent={"center"}>
            <img src={logoLolify} alt="logo" width={"20%"} />
          </Box>
        </Grid>
        <Grid item>
          <Card>
            <CardContent>
              <LoginComponent tipoLogin={value} />
            </CardContent>
          </Card>
          {/* <Box sx={{ width: "100%" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              textColor="secondary"
              indicatorColor="primary"
              variant="fullWidth"
            >
              <Tab {...a11yProps(0)} label="Proveedores" />
              <Tab {...a11yProps(1)} label="Usuarios" />
            </Tabs>
          </Box>

          <TabPanel value={value} index={0}>
            <Card>
              <CardContent>
                <LoginComponent tipoLogin={value} />
              </CardContent>
            </Card>
          </TabPanel>

          <TabPanel value={value} index={1}>
            <Card>
              <CardContent>
                <LoginComponent tipoLogin={value} />
              </CardContent>
            </Card>
          </TabPanel> */}
        </Grid>
      </Grid>
    </Box>
  );
}

export default LoginPage;
